/* MUV — Card colour swatches: persistent switch on hover.
   Sklum-style behaviour: hovering a swatch swaps the WHOLE card (main
   image + every slide in the swiper + product links + wishlist handle)
   to the sibling colour. Leaving the swatch strip does NOT restore the
   original — the change persists until another swatch is hovered.

   Slide images are fetched on-demand from /products/<handle>.js and
   memoised so repeated hovers on the same colour don't hit the network
   twice. Dots of native colour variants (data-variant-id) only use the
   photos of that colour. Missing slots (sibling has fewer images than the original)
   reuse the last available image. */
(function () {
  var CACHE = {};
  var IN_FLIGHT = {};

  function normalizeUrl(u) {
    if (!u) return u;
    if (u.indexOf('//') === 0) return 'https:' + u;
    return u;
  }

  function withWidth(u, width) {
    if (!u) return u;
    var sep = u.indexOf('?') === -1 ? '?' : '&';
    // Strip any existing width param, then append the requested one.
    var clean = u.replace(/[?&]width=\d+/, '');
    sep = clean.indexOf('?') === -1 ? '?' : '&';
    return clean + sep + 'width=' + width;
  }

  function fetchProduct(handle) {
    if (CACHE[handle]) return Promise.resolve(CACHE[handle]);
    if (IN_FLIGHT[handle]) return IN_FLIGHT[handle];
    IN_FLIGHT[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        CACHE[handle] = data;
        delete IN_FLIGHT[handle];
        return data;
      })
      .catch(function () {
        delete IN_FLIGHT[handle];
        CACHE[handle] = null;
        return null;
      });
    return IN_FLIGHT[handle];
  }

  // Same simplification as Liquid's handle filter: lower case, no accents,
  // anything that is not a letter or digit becomes a separator.
  function handleize(text) {
    return String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function allImages(data) {
    if (!data) return [];
    if (Array.isArray(data.images) && data.images.length) {
      return data.images.map(normalizeUrl);
    }
    if (Array.isArray(data.media) && data.media.length) {
      return data.media
        .filter(function (m) { return m.media_type === 'image' && m.src; })
        .map(function (m) { return normalizeUrl(m.src); });
    }
    if (data.featured_image) return [normalizeUrl(data.featured_image)];
    return [];
  }

  /* Variantes nativas de color: mismas reglas que la ficha
     (snippets/muv-variant-media-hide.liquid). La imagen de una variante abre
     el bloque de fotos de su COLOR; las fotos anteriores a la primera imagen
     de variante son comunes. Primero va la imagen de ese color. */
  /* Campo "Fotos de este color": cada punto trae los ids de sus fotos en
     data-color-media. Se enseñan esas fotos más las que no estén marcadas en
     ningún color (comunes), en el orden del producto, empezando por la imagen
     de la variante. */
  function fieldImages(data, variantId, dot) {
    var wrapper = dot.closest('.muv-card-swatches');
    var own = (dot.getAttribute('data-color-media') || '').split(',').filter(Boolean);
    var assigned = [];
    wrapper.querySelectorAll('[data-color-media]').forEach(function (d) {
      assigned = assigned.concat((d.getAttribute('data-color-media') || '').split(',').filter(Boolean));
    });
    var variant = (data.variants || []).filter(function (v) { return String(v.id) === String(variantId); })[0];
    var featuredId = variant && variant.featured_media ? String(variant.featured_media.id) : null;
    var featured = null;
    var rest = [];
    (data.media || []).forEach(function (m) {
      if (m.media_type !== 'image' || !m.src) return;
      var id = String(m.id);
      if (assigned.indexOf(id) !== -1 && own.indexOf(id) === -1) return;
      if (id === featuredId) featured = normalizeUrl(m.src);
      else rest.push(normalizeUrl(m.src));
    });
    return featured ? [featured].concat(rest) : rest;
  }

  function variantImages(data, variantId, colorIndex) {
    if (!data || !Array.isArray(data.media) || !Array.isArray(data.variants)) return allImages(data);
    var variant = data.variants.filter(function (v) { return String(v.id) === String(variantId); })[0];
    var index = Number(colorIndex);
    if (!variant || isNaN(index) || !variant.options) return allImages(data);
    var colorValue = variant.options[index];
    var groupOf = {};
    var featuredId = null;
    data.variants.forEach(function (v) {
      if (!v.featured_media || !v.featured_media.id || !v.options) return;
      if (groupOf[v.featured_media.id] === undefined) groupOf[v.featured_media.id] = v.options[index];
      if (featuredId === null && v.options[index] === colorValue) featuredId = v.featured_media.id;
    });
    var images = data.media.filter(function (m) { return m.media_type === 'image' && m.src; });
    var featured = null;
    var rest = [];
    var tagged = data.media.some(function (m) { return (m.alt || '').indexOf('#') !== -1; });
    if (tagged) {
      // "#Color" at the end of the alt text (Madrid's own method). Untagged = shared.
      var tagOf = function (alt) { return handleize(String(alt).split('#').pop()); };
      var keys = [handleize(colorValue)];
      data.variants.forEach(function (v) {
        if (v.options && v.options[index] === colorValue && v.featured_media && (v.featured_media.alt || '').indexOf('#') !== -1) {
          keys.push(tagOf(v.featured_media.alt));
        }
      });
      images.forEach(function (m) {
        if ((m.alt || '').indexOf('#') !== -1 && keys.indexOf(tagOf(m.alt)) === -1) return;
        if (m.id === featuredId) featured = normalizeUrl(m.src);
        else rest.push(normalizeUrl(m.src));
      });
      return featured ? [featured].concat(rest) : rest;
    }
    var group;
    images.forEach(function (m) {
      if (groupOf[m.id] !== undefined) group = groupOf[m.id];
      if (group !== undefined && group !== colorValue) return;
      if (m.id === featuredId) featured = normalizeUrl(m.src);
      else rest.push(normalizeUrl(m.src));
    });
    return featured ? [featured].concat(rest) : rest;
  }

  function updateSlides(card, images, native) {
    if (!images || !images.length) return;
    var swiperEl = card.querySelector('.swiper');
    var allSlides = card.querySelectorAll('.swiper-slide');
    var imgSlides = card.querySelectorAll('.swiper-slide img[class*="media--"]');
    if (!imgSlides.length) {
      // Fallback: cards outside a swiper still have media--first (and, for
      // native colour variants, the hover photo media--second).
      var single = card.querySelector('img.media--first');
      if (single) {
        single.setAttribute('srcset', '');
        single.setAttribute('src', withWidth(images[0], 1600));
      }
      var second = native ? card.querySelector('img.media--second') : null;
      if (second) {
        if (images[1]) {
          second.setAttribute('srcset', '');
          second.setAttribute('src', withWidth(images[1], 1600));
          second.style.display = '';
        } else {
          second.style.display = 'none';
        }
      }
      return;
    }
    // A colour with more photos than the slides already rendered: clone the
    // last slide so every photo of that colour gets its own slide.
    var wrapperEl = swiperEl && swiperEl.querySelector('.swiper-wrapper');
    if (native && wrapperEl && imgSlides.length < images.length) {
      var lastSlide = imgSlides[imgSlides.length - 1].closest('.swiper-slide');
      for (var c = imgSlides.length; c < images.length && lastSlide; c++) {
        var clone = lastSlide.cloneNode(true);
        clone.classList.remove('swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev', 'muv-slide-hidden');
        clone.style.display = '';
        var cloneImg = clone.querySelector('img');
        if (cloneImg) {
          cloneImg.classList.remove('media--first');
          cloneImg.classList.add('media--second');
          cloneImg.removeAttribute('fetchpriority');
          cloneImg.setAttribute('loading', 'lazy');
        }
        wrapperEl.appendChild(clone);
      }
      imgSlides = card.querySelectorAll('.swiper-slide img[class*="media--"]');
      allSlides = card.querySelectorAll('.swiper-slide');
      allSlides.forEach(function (slide) {
        if (slide.classList.contains('muv-slide-hidden')) {
          slide.classList.remove('muv-slide-hidden');
          slide.style.display = '';
        }
      });
    }
    // Restore visibility of slides hidden by a previous swatch swap so that
    // switching to a variant with MORE images works after switching to one
    // with fewer.
    allSlides.forEach(function (slide) {
      if (slide.classList.contains('muv-slide-hidden')) {
        slide.classList.remove('muv-slide-hidden');
        slide.style.display = '';
      }
    });
    // Assign each image to its slide; hide extra slides instead of reusing
    // the last image (which caused the duplicate-photo bug reported by LUV).
    imgSlides.forEach(function (img, i) {
      if (i < images.length) {
        img.setAttribute('srcset', '');
        img.setAttribute('src', withWidth(images[i], 1600));
      } else {
        var slide = img.closest('.swiper-slide');
        if (slide) {
          slide.classList.add('muv-slide-hidden');
          slide.style.display = 'none';
        }
      }
    });
    // Notify Swiper so it recalculates bullets, navigation and layout.
    if (swiperEl && swiperEl.swiper) {
      try { swiperEl.swiper.update(); } catch (e) {}
    }
  }

  function switchCard(dot) {
    var card = dot.closest('.card-wrapper')
      || dot.closest('.collection-product-card')
      || dot.closest('.product-card');
    if (!card) return;

    // Fast path: swap the immediate visible image right away so the
    // hover feels instant, then refine with the full slide set once
    // the JSON arrives. data-swatch-image was baked in at render time.
    var quick = dot.getAttribute('data-swatch-image');
    if (quick) {
      var firstImg = card.querySelector('img.media--first');
      if (firstImg) {
        firstImg.setAttribute('srcset', '');
        firstImg.setAttribute('src', quick);
      }
    }

    // Point every product link in the card (image overlay, title, cta)
    // at the sibling PDP so clicking anywhere goes to the visible colour.
    var productUrl = dot.getAttribute('href');
    if (productUrl && productUrl !== '#') {
      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        if (a.classList.contains('muv-card-swatches__dot')) return;
        a.setAttribute('href', productUrl);
      });
    }

    // Move .is-active among dots so the ring marks the visible colour.
    var wrapper = dot.closest('.muv-card-swatches');
    if (wrapper) {
      var nativeDot = dot.hasAttribute('data-variant-id');
      wrapper.querySelectorAll('.muv-card-swatches__dot').forEach(function (d) {
        d.classList.remove('is-active');
        if (nativeDot) d.removeAttribute('aria-current');
      });
      dot.classList.add('is-active');
      if (nativeDot) dot.setAttribute('aria-current', 'true');
    }

    // Wishlist handle + data-product must reference the visible colour
    // so the heart toggle and any analytics attribute point right.
    var handleMatch = productUrl && productUrl.match(/\/products\/([^/?#]+)/);
    if (!handleMatch) return;
    var handle = handleMatch[1];
    var dotVariantId = dot.getAttribute('data-variant-id');
    // Native colour variants: the wishlist entry and the quick "+" follow the
    // colour of the dot (handle?variant=ID and the variant id).
    var wishlistKey = dotVariantId ? handle + '?variant=' + dotVariantId : handle;
    card.querySelectorAll('[data-wishlist-handle]').forEach(function (btn) {
      btn.setAttribute('data-wishlist-handle', wishlistKey);
    });
    if (dotVariantId) {
      card.querySelectorAll('form input[name="id"]').forEach(function (input) {
        input.value = dotVariantId;
      });
      var dotAvailable = dot.getAttribute('data-variant-available') !== 'false';
      card.querySelectorAll('product-form button[name="add"]').forEach(function (button) {
        button.disabled = !dotAvailable;
      });
      card.querySelectorAll('[data-product-url]').forEach(function (el) {
        el.setAttribute('data-product-url', productUrl);
      });
    }
    if (dotVariantId && window.muvWishlistRefresh) window.muvWishlistRefresh();
    var productHost = card.querySelector('[data-product]');
    if (productHost) productHost.setAttribute('data-product', handle);

    // Full-swap: pull the images of the colour and paint all slides. For
    // native colour variants only that variant's photo block is used.
    var variantId = dot.getAttribute('data-variant-id');
    var swapToken = handle + '|' + (variantId || '');
    card.setAttribute('data-muv-swap', swapToken);
    fetchProduct(handle).then(function (data) {
      // A later hover on another dot wins: ignore late responses.
      if (card.getAttribute('data-muv-swap') !== swapToken) return;
      var colorIndex = dot.closest('.muv-card-swatches') && dot.closest('.muv-card-swatches').getAttribute('data-color-index');
      var images = !variantId ? allImages(data)
        : dot.hasAttribute('data-color-media') ? fieldImages(data, variantId, dot)
        : variantImages(data, variantId, colorIndex);
      updateSlides(card, images, !!variantId);
    });
  }

  // Used by recently viewed to show the colour the visitor looked at.
  window.muvCardShowVariant = function (card, variantId) {
    if (!card || !variantId) return;
    var dot = card.querySelector('.muv-card-swatches__dot[data-variant-id="' + variantId + '"]');
    if (dot && !dot.classList.contains('is-active')) switchCard(dot);
  };

  document.addEventListener('mouseover', function (e) {
    var dot = e.target && e.target.closest && e.target.closest('.muv-card-swatches__dot');
    if (!dot) return;
    switchCard(dot);
  });

  document.addEventListener('touchstart', function (e) {
    var dot = e.target && e.target.closest && e.target.closest('.muv-card-swatches__dot');
    if (!dot) return;
    switchCard(dot);
  }, { passive: true });
})();
